import React from "react";
import {
  getPackageBookingRemainingSeconds,
  PackageBookingDate,
} from "../common/util/packageBookingExpiration";

export const usePackageBookingExpiration = (
  bookingDate: PackageBookingDate,
) => {
  const lastKnownBookingDate = React.useRef<PackageBookingDate>();
  if (getPackageBookingRemainingSeconds(bookingDate) !== null) {
    lastKnownBookingDate.current = bookingDate;
  }

  const [remainingSeconds, setRemainingSeconds] = React.useState<number | null>(
    () => getPackageBookingRemainingSeconds(bookingDate),
  );

  React.useEffect(() => {
    const effectiveBookingDate =
      getPackageBookingRemainingSeconds(bookingDate) === null
        ? lastKnownBookingDate.current
        : bookingDate;
    const updateRemainingSeconds = () => {
      const nextRemainingSeconds =
        getPackageBookingRemainingSeconds(effectiveBookingDate);
      setRemainingSeconds(nextRemainingSeconds);
    };

    updateRemainingSeconds();
    if (effectiveBookingDate == null) return;

    const timerId = window.setInterval(updateRemainingSeconds, 1000);
    return () => window.clearInterval(timerId);
  }, [bookingDate]);

  return remainingSeconds;
};
